/*******************************************************************************
 * Copyright (c) 2024. dnote.ai
 *
 * @project DNOTE.AI-Frontend
 * @author dnote.ai
 * @copyright Dnote.ai All rights reserved
 ******************************************************************************/

import "./assets/js/nav-pills.js";
import "./assets/js/ripple-effect.js";
import "./assets/scss/chris-dashboard.scss";

export default {
  install() {},
};
